import { authUserAddFeatureToSeenMeta } from 'app/rest/effects/authUser/authUserAddFeatureToSeenMeta';
import { EFeature } from 'app/types/rest/IUserMeta';
import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../../types/types';

export const onSubTabChange = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(authUserAddFeatureToSeenMeta(EFeature.BOARD_SPLIT_SETTINGS));
    };
    return action;
};
